<template>
  <el-dialog label-width="120px" label-position="top" :fullscreen="true" :visible="display"
             @closed="closed" @close="$emit('close', false)" @opened="opened" :destroy-on-close="true">
    <slot name="title">
      <h3 class="text-center">{{ $t(`pos.title.${edit ? 'update' : 'create'}`, { name: form.name }) }}</h3>
      <hr>
    </slot>
    <el-row>
      <el-col :span="12" :offset="6">
        <el-form ref="disForm" :model="form" :rules="rules" label-width="150px" label-position="top" status-icon>
          <el-form-item :label="$t('pos.form.name')" prop="name">
            <el-input v-model="form.name" ref="input"></el-input>
          </el-form-item>
          <el-form-item :label="$t('pos.form.store')" prop="type">
            <el-select class="full-width" v-model="form.store" collapse-tags clearable>
              <el-option
                v-for="item in stores"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>

    </el-row>
    <template #footer>
      <el-row class="dialog-footer">
        <el-col :span="12" :offset="6">
          <el-button @click="$emit('close', false)">Cancel</el-button>
          <el-button :disabled="!submittable" :loading="loading" type="primary" @click="submitForm">
            {{ $t(`pos.button.${edit ? 'update' : 'create'}`) }}
          </el-button>
        </el-col>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreatePOS',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    pos: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      stores: [],
      form: {
        name: '',
        store: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Please specify the POS name',
            trigger: ['change', 'blur']
          },
          {
            min: 3,
            message: 'Length should be at least 3',
            trigger: ['change', 'blur']
          }
        ],
        store: [
          {
            required: true,
            message: 'Please select the Department',
            trigger: ['change', 'blur']
          }
        ]
      },
      loading: false
    }
  },
  computed: {
    submittable () {
      return !Object.keys(this.form).filter(k => (typeof this.form[k] !== 'boolean') && !this.form[k]).length
    },
    edit () {
      return this.pos && this.pos.id
    }
  },
  methods: {
    handleValueChange (_) {
    },
    focusedValueField (_) {
      if (this.form.value <= 0) {
        this.$refs.valueField.select()
      }
    },
    opened () {
      if (this.edit) {
        this.form.name = this.pos.name
        this.form.store = this.pos.store.id
      }
      this.$refs.input.focus()
    },
    closed () {
      this.form.name = ''
      this.form.store = ''
      this.loading = false
    },
    async submitForm () {
      this.$refs.disForm.validate(async (valid) => {
        if (valid) {
          this.askQuestion(this.$t(`pos.confirm.${this.edit ? 'update' : 'create'}`), async () => {
            try {
              await this.withLoading(async () => {
                if (this.edit) {
                  const data = await this.$posService.updatePOS(this.pos.id, this.form)
                  this.showSuccess(this.$t('pos.message.updated'))
                  this.$emit('updated', data)
                  this.$emit('close')
                } else {
                  const data = await this.$posService.createPOS(this.form)
                  this.showSuccess(this.$t('pos.message.created'))
                  this.$emit('created', data)
                  this.$emit('close')
                }
              }, 'loading', {
                component: 'CreateEditPOS',
                action: this.edit ? 'updatePOS' : 'createPOS',
                formData: this.form
              })
            } catch (error) {
              // Error is already handled by the global interceptor
              console.log('Component caught error in updatePOS|createPOS:', error)
            }
          })
        }
      })
    }
  },
  async mounted () {
    await this.$storeService.getStores()
      .then(data => {
        this.stores = data
      })
  }
}
</script>

<style scoped>

</style>
